module.exports = __webpack_public_path__ + "static/media/marriage-7.cf23d3e3.jpg";